import { formatDateTimeFull } from '../../../helpers/formatDate'
import { RBAC_STATUS_COLORS } from '../../components/constants/rbacChipColors'

export function formatRbacUserDate(value) {
  return value ? formatDateTimeFull(value) : '—'
}

export function getRbacUserDisplayName(user) {
  return user?.name || user?.email || '—'
}

export function getRbacUserStatusMeta(user) {
  if (user?.status === 'pending' || (!user?.active && user?.email_verified === false)) {
    return {
      label: 'PENDIENTE',
      color: RBAC_STATUS_COLORS.pending.text,
      backgroundColor: RBAC_STATUS_COLORS.pending.background
    }
  }

  if (user?.status === 'inactive' || user?.active === false) {
    return {
      label: 'INACTIVO',
      color: RBAC_STATUS_COLORS.inactive.text,
      backgroundColor: RBAC_STATUS_COLORS.inactive.background
    }
  }

  return {
    label: 'ACTIVO',
    color: RBAC_STATUS_COLORS.active.text,
    backgroundColor: RBAC_STATUS_COLORS.active.background
  }
}

export function isRbacUserPending(user) {
  return user?.status === 'pending' || (!user?.active && user?.email_verified === false)
}

export function getRbacUserInitials(value) {
  const parts = String(value || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)

  return parts
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}

export function getRbacUserPrimaryRoleName(user) {
  const roleName = user?.roles?.[0]?.name
  return roleName || 'SIN ROL'
}

export function formatRbacUserCreatedBy(user) {
  const creator = user?.created_by || user?.created_by_name

  if (!creator) return '—'
  if (typeof creator === 'string') return creator

  return creator.name || creator.email || '—'
}

export function buildRbacUserNameFields(user) {
  if (user?.first_name || user?.last_name) {
    const fullName = [user.first_name, user.last_name].filter(Boolean).join(' ')
    return [{ label: 'Nombre completo', value: fullName }]
  }

  return [{ label: 'Nombre completo', value: user?.name }]
}

export function getRbacInvitationResendRemainingMs(user, now = Date.now()) {
  const availableAt = user?.invitation_resend_available_at
  if (!availableAt) return 0

  const timestamp = new Date(availableAt).getTime()
  if (Number.isNaN(timestamp)) return 0

  return Math.max(0, timestamp - now)
}

export function formatRbacInvitationResendCountdown(ms) {
  if (ms <= 0) return ''

  const totalMinutes = Math.max(1, Math.ceil(ms / 60000))
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (hours > 0 && minutes > 0) return `${hours} h ${minutes} min`
  if (hours > 0) return `${hours} h`

  return `${minutes} min`
}

export function isRbacInvitationResendOnCooldown(user, now = Date.now()) {
  return getRbacInvitationResendRemainingMs(user, now) > 0
}

export function normalizeRbacOptionalText(value) {
  return String(value || '').trim()
}

export function areRbacRoleIdListsEqual(left = [], right = []) {
  if (left.length !== right.length) return false

  return left.every((roleId, index) => String(roleId) === String(right[index]))
}

export function haveRbacUserRolesChanged(formRoleIds, userRoleIds) {
  return !areRbacRoleIdListsEqual(formRoleIds, userRoleIds)
}

export function buildRbacUserProfileUpdatePayload(form, user) {
  const payload = {}
  const nextName = normalizeRbacOptionalText(form?.name)
  const nextEmail = normalizeRbacOptionalText(form?.email)
  const nextPhone = normalizeRbacOptionalText(form?.phone)
  const currentName = normalizeRbacOptionalText(user?.name)
  const currentEmail = normalizeRbacOptionalText(user?.email)
  const currentPhone = normalizeRbacOptionalText(user?.phone)

  if (nextName !== currentName) payload.name = nextName
  if (isRbacUserPending(user) && nextEmail !== currentEmail) payload.email = nextEmail
  if (nextPhone !== currentPhone) payload.phone = nextPhone || null

  return payload
}
